export default { ANDROID_CHROME: 'Android Chrome', DESKTOP_CHROME: 'Desktop Chrome', ANDROID_OTHER: 'Android Other', IOS_ALL: 'IOS All', MAC_ALL: 'MAC All', MAC_CHROME: 'MAC Chrome' };


// WEBPACK FOOTER //
// ./src/scenes/AdkBannerFeeds/device.config.js